/*
  stringtrim

usage:
  var stringtrim = require('./stringtrim'):
  var trimmed = stringtrim.innermultiplespace('some   string with    lots of  space');
  //'some string with lots of space'

return:
  the modified string
*/

const filterAwayNonDigits = function(str) {
	/*filter away all but 0-9*/
	return str.replace(/[^(0-9)]/g, '');
};

const multipleSpaceToSingle = function(str) {
	//TODO add unit test to confirm functionality!!
	const multispace = new RegExp(/\s{2,}/g);
	return str.replace(multispace, ' ');
};

const removeTrailingSpace = function(str) {
	//TODO add unit test to confirm functionality!!
    // compare native 'String.trim' method
	const trailspace = new RegExp(/^[ \s]+|[ \s]+$/g);
	return str.replace(trailspace, '');
};

export default {
	multispace(str) {
		// var trimmed = return (str? multipleSpaceToSingle(str) : null);
		// return multipleSpaceToSingle(str);
		return (str ? multipleSpaceToSingle(str) : null);
	},
	trailspace(str) {
		return (str ? removeTrailingSpace(str) : null);
		// return removeTrailingSpace(str);
	},
	keepdigits(t) {
		/*returns all digits from a string*/
		let str;

		let digits;
		let num;
		if (t) {
			str = t.toString();
			digits = filterAwayNonDigits(str);
			num = parseInt(digits, 10);
		} else {
			num = null;
		}
		return num;
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/stringtrim.js